<template>
    <div>
        <ul class="main-menu-bar visible" style="margin: 0">
                <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 0 == activeTab}]" tag="li" @click="changeTab(0)">
                        <IconButton :text="'ROUGHAGE'">
                            <img src="~@/assets/img/Menu/Systems.svg" />
                        </IconButton>
                    </div>
                </div>
                <div>
                    <div :class="['charts-header-tab-title', 'menuitem', {'charts-header-tab-title-active': 1 == activeTab}]" tag="li"  @click="changeTab(1)">
                        <IconButton :text="'SORTING'">
                            <img src="~@/assets/img/Menu/Systems.svg" />
                        </IconButton>
                    </div>
                </div>
            </ul>
        <div class="chart">
            <div v-if="spin == true" class="mySpinner">
                <Spinner style="width: 100%; position: fixed; top: 50vh;"></Spinner>
            </div>
            <settings-roughage ref="c-0" v-if="activeTab == 0" @spin="(v) => spin = v" :systemId="systemObject.id"></settings-roughage>
            <settings-sorting ref="c-1" v-if="activeTab == 1" @spin="(v) => spin = v" :systemId="systemObject.id"></settings-sorting>
        </div>
    </div>
</template>

<script>
import SettingsSorting from '@/views/System/SettingsSorting.vue'
import SettingsRoughage from '@/views/System/SettingsRoughage.vue'
import Spinner from 'vue-simple-spinner'
import IconButton from '@/components/IconButton'

export default {
    props: {
        systemObject: {
            type: Object,
            required: true
        }
    },
    components: {
      SettingsSorting,
      Spinner,
      IconButton,
      SettingsRoughage
    },
    data() {
        return {
          spin: false,
          activeTab: 0,
        }
    },
    methods: {
      async changeTab(tabNumber){
            if(this.activeTab != tabNumber){
                this.activeTab = tabNumber
            }
        },
    },
    mounted: async function() {
    },
}
</script>

<style>
.charts-header-tab-title-active .selected{
    /* border-bottom: 4px solid white !important; */
    border-bottom: 4px solid white !important;
    margin-bottom: 0px;
    border-radius: 15px;
    width: 120%;
}
</style>

<style scoped>
.charts-header-tab-title {
    color: white;
    margin: 10px 30px 10px 30px;
    cursor: pointer;
    font-family: 'SourceSansProSemiBold', sans-serif !important;
}

.charts-header {
    padding: 0;
    padding-right: 50px;
    margin: 0;
    background-color: #0095B2;
    width: 100%;
    height: 100px;
    align-items: center;
    justify-content: start;
}

.chart {
    padding: 10px;
}

.mySpinner {
    position: absolute;
    z-index: 300;
    left: 0;
    top: 143px;
    width: 100%;
    height: calc(100% - 143px);
    overflow: auto;
    display: block;
    background-color: rgba(0,0,0,0.4);
}

.main-menu-bar {
    grid-template-columns: repeat(2, minmax(160px, 200px));
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/SettingsModal.vue